import React from "react";
import "../footer/footer.css";

const Footer = () => {
  return (
    <footer className=" text-light py-4 f-dynamic" style={{ background: "#f2f2f3" }}>
      <div className="container">
        <div className="row d-flex flex-wrap">
          <div className="col-12 d-flex flex-column flex-md-row">
            <div
              
              style={{
                fontSize: 15,
                fontWeight: "bold",
                color: "black",
              }}
            >
              <p className="login-note">
                Logging in is only required for editing and submitting new companies.
                <br />
                If you had an account on the Working Forest Planner, you can use the same credentials to login.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
